import { getFullDate } from '../PublishSendSessionModal';

export default function templateConvocatoria(dataSession) {
	const mailTemplateConvocatoria =
		`<div style="text-align:justify;">
		<p><strong>#usuario#,</strong></p>
		<br>
		<p>Con fundamento en el artículo <strong>` +
		dataSession.fundamento_juridico +
		`</strong> de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores y en lo dispuesto en el Libro II, Capítulo II, Regla 66°, fracción II y 69°, fracción II de las Reglas de Operación de los Órganos Colegiados, convoco a usted a la sesión <strong> ` +
		dataSession.numero_sesion +
		`</strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> que se llevará a cabo ` +
		`<strong>${getFullDate(dataSession.fhora)}</strong>` +
		`, misma que se llevará a cabo de manera presencial en la Sala de Consejo Don Fidel Velázquez Sánchez,</strong> ubicada en el cuarto piso del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, con domicilio en avenida Barranca del Muerto número 280, colonia Guadalupe Inn, código postal 01020, Álvaro Obregón, en la Ciudad de México.</span></p>
		<br>
		<p>La sesión <strong><a href="` +
		window.location.href +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> puedes consultarla haciendo click en el vínculo.</p>
		<br>
		<br>
		<b>Atentamente</b>
		<br>
		<br>
		<b><strong>Marcos Manuel Herrería Alamina</strong></b>
		<br>
		<b><strong>Secretario General y Jurídico del Instituto del Fondo Nacional de la Vivienda para los Trabajadores.</strong></b> 
		</div>
		`;
	const mailTemplateConvocatoriaIncoformidades =
		`<div style="text-align:justify;">
		<p><strong>#usuario#,</strong></p>
		<br>
		<p>Con fundamento en el artículo <strong>` +
		dataSession.fundamento_juridico +
		`</strong> de la Ley del Instituto del Fondo Nacional de la Vivienda para los Trabajadores y en lo dispuesto en el Libro II, Capítulo I, Regla 66°, fracción IV y 67° Bis y 69°, fracción III y 71 de las Reglas de Operación de los Órganos Colegiados, aprobadas por la Asamblea General, convoco a usted a la sesión <strong> ` +
		dataSession.numero_sesion +
		`</strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> que se llevará a cabo ` +
		`<strong>${getFullDate(dataSession.fhora)}</strong>` +
		` misma que se llevará a cabo de manera presencial en la Sala de Cómites,</strong> ubicada en el cuarto piso, del Edificio sede del Instituto del Fondo Nacional de la Vivienda para los Trabajadores, con domicilio en avenida Barranca del Muerto número 280, colonia Guadalupe Inn, código postal 01020, Álvaro Obregón, en la Ciudad de México.</span></p>
		<br>
		<p>Agradecemos confirme su asistencia <strong><a href="` +
		window.location.href +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> dando click en éste enlace.</p>
		<br>
		<br>
		<p>Atentamente</p>
		<br>
		<p><strong>Lic. Patricia González Sánchez</strong></p>
		<p><strong>Secretaria Técnica de la Comisión de Inconformidades</strong></p>
		</div>
		`;

	return dataSession.nameOrgan === 'Comisión de Inconformidades'
		? mailTemplateConvocatoriaIncoformidades
		: mailTemplateConvocatoria;
}
